module.exports = __webpack_public_path__ + "img/CAL-UHF-S.571bcb53.png";